import axios from 'axios';
import { useEffect, useState } from 'react';

export interface Bank {
  bankCode: string;
  name: string;
}

interface Result {
  banks: Bank[];
}

export const useBankFromGeoIP = (): Result => {
  const [bankObjects, setBankObjects] = useState([]);

  useEffect(() => {
    const getGeoZip = async () => {
      let result = [];

      try {
        const response = await axios.get(process.env.ASSIGNMENT_API_ENDPOINT);

        if (response.data.error) {
          throw response.data.error;
        }

        result = response.data.institutes.items.map((entry) => {
          return { bankCode: `${entry.bin}`, name: `${entry.name}` };
        });
      } catch (e) {
        console.error({ 'getGeoZip error': e });
      }

      setBankObjects(result);
    };

    getGeoZip().catch((e) => {
      if (axios.isCancel(e)) {
        return;
      }
      // eslint-disable-next-line no-console
      console.error(e);
      setBankObjects([]);
    });
  }, []);
  return { banks: bankObjects };
};
